import { useState, Fragment, useEffect } from 'react'
import Modal from '@components/modal'
import { Formik, Form } from 'formik'
import { FC } from 'react'
import Column from '@components/column'
import Typography from '@components/typography'
import Fields from '@components/fields'
import { StyleWeekDay, StyleWeekWrapper } from './style'
import { format } from 'date-fns'
import { Availability, Appointment } from '@apis'
import { Helper } from '@utils'
import Button from '@components/button'
import { useSelector } from 'react-redux'
import { AppointmentSchema } from '@validations'
interface AppointmentRescheduleProps {
  id: any
  visible: boolean
  onClose: () => void
  appointment: any
  selector: any
}
const AppointmentReschedule: FC<AppointmentRescheduleProps> = ({
  id,
  visible,
  onClose,
  appointment,
  selector,
}) => {
  const dates = Helper.getNext7Dates(appointment?.date)
  const { data: availabilities } = useSelector(
    (state: any) => state.availabilities,
  )
  const [loading, setLoading] = useState<boolean>(false)
  const { data: user } = useSelector((state: any) => state.user)
  const [initialValues, setInitialValues] = useState({
    appointmentType: appointment?.infos?.appointmentType,
    date: format(appointment?.date, 'yyyy-MM-dd'),
    shift: appointment?.infos?.shift,
    shareAnything: appointment?.infos.shareAnything,
    time: format(appointment?.date, 'HH:mm'),
  })
  const fetchAvailabilities = async () => {
    await Availability.list({
      params: {
        userId: user?.id,
      },
    }).catch(() => {})
  }
  const submitHandler = async (values) => {
    setLoading(true)
    await Appointment.reschedule({
      data: {
        appointmentType: values?.appointmentType,
        date: values?.date,
        time: values?.time,
        shift: values?.shift,
      },
      id: appointment?.id,
      state: selector,
    }).catch(() => {})
    setLoading(false)
  }
  useEffect(() => {
    if (!availabilities?.length) {
      fetchAvailabilities()
    }
  }, [])
  return (
    <Modal onClose={onClose} visible={visible} title="Reschedule Appointment">
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
        validationSchema={AppointmentSchema.rescheduleValidationSchema}
      >
        {({ handleSubmit, values, setFieldValue }) => {
          const availability = availabilities?.find(
            (availability: any) =>
              availability?.day == format(values?.date, 'EEEE'),
          )

          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <Fields.ChooseButton
                  name="appointmentType"
                  items={[
                    {
                      label: 'Schedule',
                    },
                    {
                      label: 'Instant',
                    },
                    {
                      label: 'At Clinic',
                    },
                  ]}
                  titleAsKey="label"
                  valueAsKey="label"
                  label="Appointment Type"
                  multiple={false}
                />
                <Column rowGap={10}>
                  <Typography content="Rechedule Date" size={14} />
                  <StyleWeekWrapper
                    onClick={() => {
                      const date = (event.target as HTMLElement)
                        .closest('[data-date]')
                        ?.getAttribute('data-date')

                      if (id) {
                        setFieldValue('date', date)
                      }
                    }}
                  >
                    {dates?.map((date: any) => {
                      const isActive = values?.date == date
                      return (
                        <Fragment key={date}>
                          <StyleWeekDay isActive={isActive} data-date={date}>
                            <Typography
                              content={format(date, 'eee')}
                              size={14}
                              tc={!!isActive ? 'white' : 'text'}
                            />
                            {format(date, 'dd')}
                          </StyleWeekDay>
                        </Fragment>
                      )
                    })}
                  </StyleWeekWrapper>
                </Column>
                <Fields.ChooseButton
                  name="shift"
                  label="Available Time"
                  items={[
                    {
                      label: 'Morning',
                    },
                    {
                      label: 'Afternoon',
                    },
                    {
                      label: 'Evening',
                    },
                  ]}
                  titleAsKey="label"
                  valueAsKey="label"
                  multiple={false}
                />
                <Fields.ChooseButton
                  name="time"
                  items={
                    availability?.slots?.[values?.shift?.toLowerCase()]?.map(
                      (slot) => {
                        return {
                          label: slot?.startTime,
                        }
                      },
                    ) || []
                  }
                  titleAsKey="label"
                  valueAsKey="label"
                  multiple={false}
                />
                <Fields.TextArea
                  name="shareAnything"
                  label="Anything you want to share"
                  placeholder="Any additional information you want to share..."
                  disabled
                />
                <Button
                  type="submit"
                  title="Confirm"
                  height={40}
                  styleButton="width:100%"
                  loading={loading}
                />
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default AppointmentReschedule
